import MEDIA_PLAYER from './media-player-events';
import HTML5 from './html5-player-events';
import HLSJS from './hlsjs-player-events';

export default {
    HTML5,
    MEDIA_PLAYER,
    HLSJS,
};
